export var getCommonProps = function getCommonProps(user) {
  if (typeof window !== 'undefined') {
    var _window, _window2, _window2$location, _document;
    return {
      page_url: (_window = window) === null || _window === void 0 ? void 0 : _window.origin,
      page_path: (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.pathname,
      page_title: (_document = document) === null || _document === void 0 ? void 0 : _document.title,
      account_type: user || 'none'
    };
  }
  return {};
};